// SPDX-License-Identifier: AGPL-3.0-or-later

/** Check the release served by this installation, including desktop webviews and PWAs. */
export async function checkWebRelease(currentVersion: string | null): Promise<{
	available: boolean;
	version: string;
} | null> {
	if (!currentVersion || currentVersion === 'dev') return null;
	try {
		const response = await fetch('/version.json', {
			cache: 'no-store',
			headers: {'Cache-Control': 'no-cache'},
			signal: AbortSignal.timeout(10000),
		});
		if (!response.ok) return null;
		const payload: unknown = await response.json();
		if (!payload || typeof payload !== 'object') return null;
		const {version, buildVersion} = payload as {version?: unknown; buildVersion?: unknown};
		const latest = version ?? buildVersion;
		if (typeof latest !== 'string' || !latest.trim() || latest === 'dev') return null;
		return {available: latest !== currentVersion, version: latest};
	} catch {
		// A failed/offline check must not clear an update already found.
		return null;
	}
}
